import classes from './DaysAgoBox.module.css'

export default function DaysAgoBox({days}) {

    let warningClass = null;
    if (days) {
        if (days > 7) {
            warningClass = 'red';
        } else if (days > 3) {
            warningClass = 'yellow';
        }
    }


    // old code
    // const [warningClass, setWarningClass] = useState(null)

    // useEffect(() => {
    //     if (days) {
    //         if (days > 7) {
    //             setWarningClass('red')
    //         } else if (days > 3) {
    //             setWarningClass('yellow')
    //         } else {
    //             setWarningClass(null)
    //         }
    //     }
    // }, [days])
    return <div className={`${classes.container} ${warningClass ? classes[warningClass] : ''}`} title='days ago'>
        {days}
    </div>
}